import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import { useLocalization } from '../../../localization'
import {
  CBAlert,
  CBList,
  CBListItem
} from '../../core/components/cbd'
import { faPencilAlt, faSyncAlt, faTrashAlt, faWrench } from '@fortawesome/free-solid-svg-icons' // Added faTrashAlt, faWrench
// Removed Ant Design icons import
// Removed Menu, Modal, Progress imports
import { API } from 'aws-amplify'
import { useGlobalState } from '../../../store'
// Added CB component imports
import { CBButton, CBModal } from '../../core/components/cbd'; // Added CBButton, CBModal
import { CBDropdown, CBMenu, CBMenuItem } from '../../core/components/CBDropdown';
import { CBProgress } from '../../core/components/CBProgress'; // Original Progress, might be removable later if not used elsewhere
import CBCircularProgress from '../../core/components/CBCircularProgress'; // Import the new component
import { accountIconMap } from '../../../utils/customIcons'
import { syncFilterText, syncTypeText } from '../../../utils/words'
import ColorPicker from './ColorPicker'

import { ReactComponent as Connections } from '../../../images/svg/connections.svg'


import { useNavigate } from 'react-router-dom'
// const syncStatusMap = {
//   synced: colorNeutral,
//   syncing: colorPositive,
//   synced_error: colorNegative,
//   deleting: colorNegative,
// }

const syncStatusMap = {
  synced: 'normal',
  syncing: 'normal',
  delete_error: 'exception',
  synced_error: 'exception',
  sync_conflict: 'exception',
  sync_conflict_onecal: 'exception',
  deleting: 'exception',
  synced_renew: 'exception',
}

const SyncItem = ({ item, preview = false }) => {
  const navigate = useNavigate();
  const { t } = useLocalization();
  const [accounts] = useGlobalState('accounts')
  const [license] = useGlobalState('license')
  const [disableButton, setDisableButton] = useState(false)

  // Modal States
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showForceDeleteModal, setShowForceDeleteModal] = useState(false);
  const [showResyncModal, setShowResyncModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showRepairModal, setShowRepairModal] = useState(false);

  const findSource = accounts.filter(
    (a) => item.sourceCalendarAccountId === a.calendarAccountId
  )
  {
    // console.log(item)
  }
  const sourceAccount =
    findSource.length > 0
      ? findSource[0]
      : item.sourceCalendarType == 'ics'
      ? { email: t('sync.item.icsUrl') }
      : { email: t('sync.item.accountMissing') }
  console.log(sourceAccount)
  const findDest = accounts.filter(
    (a) => item.destCalendarAccountId === a.calendarAccountId
  )
  const destAccount =
    findDest.length > 0
      ? findDest[0]
      : { email: t('sync.item.accountMissing') }

  if (!sourceAccount || !destAccount) {
    console.log('FAILED')
    return null
  }

  function getTypeIcon(type) {
    if (type == 'ics') {
      return (
        <div className="flex justify-center mt-1">
          <Connections></Connections>
        </div>
      )
    }
    return (
      <FontAwesomeIcon
        icon={accountIconMap[type].icon}
        style={{
          marginLeft: 0,
          marginRight: 0,
          display: 'inline-block',
        }}
      />
    )
  }

  function resolveError() {
    var str = item.errorState
    if (str.includes('Auth token refresh failed for')) {
      //re-authenticate account with link
      var accountId = str.substring(str.indexOf('for ') + 4)

      if (item.status == 'delete_error') {
        return (
          <>
            <a href={`/dashboard/accounts/`}>
              <CBAlert
                message={t('sync.item.errorDeleteAuth', { email: accountId == destAccount.calendarAccountId ? destAccount.email : sourceAccount.email })}
                type="error"
                showIcon
              >{t('sync.item.errorDeleteAuth', { email: accountId == destAccount.calendarAccountId ? destAccount.email : sourceAccount.email })}</CBAlert>
            </a>
          </>
        )
      } else {
        return (
          <>
            <a href={`/dashboard/accounts/`}>
              <CBAlert
                message={t('sync.item.errorAccountAuth', { email: accountId == destAccount.calendarAccountId ? destAccount.email : sourceAccount.email })}
                type="error"
                showIcon
              >{t('sync.item.errorAccountAuth', { email: accountId == destAccount.calendarAccountId ? destAccount.email : sourceAccount.email })}</CBAlert>
            </a>
          </>
        )
      }
    } else if (str.includes('timeout') || str.includes('timed out')) {
      return (
        <>
          <a href="https://help.calendarbridge.com/doc/sync-troubleshooting/temporary-connection-issues/">
            <CBAlert
              message={t('sync.item.errorConnectionTemp')}
              type="info"
              showIcon
            >
              {t('sync.item.errorConnectionTemp')}
            </CBAlert>
          </a>
        </>
      )
    }else if (str.includes('403') && item.destCalendarType == "ms" && item.sourceCalendarType != "ics") {
      return (
        <>
          <a href="https://help.calendarbridge.com/user-docs/syncing-shared-and-resource-calendars/">
            <CBAlert
              message={t('sync.item.errorSharedCalendar')}
              type="error"
              showIcon
            >
              {t('sync.item.errorSharedCalendar')}
            </CBAlert>
          </a>
        </>
      )
    } else if (str.includes('Forbidden') && str.includes('Google')) {
      return (
        <>
          <a href="https://help.calendarbridge.com/doc/account-management/reauthenticating-with-a-google-account/">
            <CBAlert
              message={t('sync.item.errorGooglePerms')}
              type="error"
              showIcon
            >
              {t('sync.item.errorGooglePerms')}
            </CBAlert>
          </a>
        </>
      )
    } else if (
      str.includes('insufficientPermissions') &&
      str.includes('Google')
    ) {
      return (
        <>
          <a href="https://help.calendarbridge.com/doc/account-management/reauthenticating-with-a-google-account/">
            <CBAlert
              message={t('sync.item.errorGooglePerms')}
              type="error"
              showIcon
            >
              {t('sync.item.errorGooglePerms')}
            </CBAlert>
          </a>
        </>
      )
    } else if (
      str.includes('rateLimitExceeded') ||
      str.includes('usageLimits')
    ) {
      return (
        <>
          <a href="https://help.calendarbridge.com/doc/sync-troubleshooting/rate-limiting/">
            <CBAlert
              message={t('sync.item.errorRateLimit')}
              type="info"
              showIcon
            >
              
            </CBAlert>
          </a>
        </>
      )
    } else if (item.status == 'sync_conflict_onecal') {
      return (
        <>
          <a href="https://help.calendarbridge.com/doc/sync-troubleshooting/">
            <CBAlert
              message={
                t('sync.item.errorConflictOnecal')
              }
              type="error"
              showIcon
            >
              
            </CBAlert>
          </a>
        </>
      )
    } else if (item.status == 'sync_conflict') {
      return (
        <>
          <a href="https://help.calendarbridge.com/doc/sync-troubleshooting/">
            <CBAlert
              message={
                t('sync.item.errorConflictReclaimClockwise')
              }
              type="error"
              showIcon
            >
              
            </CBAlert>
          </a>
        </>
      )
    } else if (str.includes('Invalid User')) {
      return (
        <>
          <a href="https://help.calendarbridge.com/doc/sync-troubleshooting/">
            <CBAlert
              message={
                t('sync.item.errorDestMsChanged')
              }
              type="info"
              showIcon
            >
             
            </CBAlert>
          </a>
        </>
      )
    } else {
      //divine the 403
      if (item.status == 'delete_error') {
        return (
          <>
            <a href={`/dashboard/accounts/`}>
              <CBAlert
                message={t('sync.item.errorDeleteAuthGeneral')}
                type="error"
                showIcon
              >
                
              </CBAlert>
            </a>{' '}
          </>
        )
      } else if (item.status == 'deleting') {
        return (
          <a onClick={(e) => window.location.reload()}>
            <CBAlert message={t('sync.item.statusDesyncing')} type="info" showIcon>
              
            </CBAlert>
          </a>
        )
      } else if (item.status == 'synced_renew') {
        return (
          <a
            onClick={(e) =>
              navigate(
                `/dashboard/syncs/${encodeURIComponent(
                  item.id.replace('#', '___')
                )}/edit`
              )
            }
          >
            <CBAlert message={t('sync.item.statusTapToEdit')} type="info" showIcon>
              
            </CBAlert>
          </a>
        )
      } else if (str == '' || str == null || str == undefined) {
        return <></>
      } else {
        return <></>
        //flesh out 403 google shit
        // return (
        //   <a href={`https://help.calendarbridge.com/request-support/`}>
        //     <Alert
        //       message="Sync issue please tap here to contact support. Do not delete or edit sync or re-authenticate any accounts"
        //       type="error"
        //       showIcon
        //     ></Alert>
        //   </a>
        // )
      }
    }
  }

  // --- Modal Handlers ---
  const handleDeleteConfirm = async () => {
    setShowDeleteModal(false);
    try {
      await API.del('bridge', '/bridge', { body: { sourceCalendarId: item.sourceCalendarId, destCalendarId: item.destCalendarId } });
      window.dataLayer?.push({ event: 'dashboardEvent', category: 'userActivity', action: 'deleteSync', label: license.userId, email: license.email });
      window.location.reload();
    } catch (error) { console.error("Delete failed:", error); alert(t('sync.item.alertDeleteFailed')); }
  };

  const handleForceDeleteConfirm = async () => {
    setShowForceDeleteModal(false);
     try {
      await API.del('bridge', '/bridge?force=true', { body: { sourceCalendarId: item.sourceCalendarId, destCalendarId: item.destCalendarId } });
      window.dataLayer?.push({ event: 'dashboardEvent', category: 'userActivity', action: 'deleteSync', label: license.userId, email: license.email });
      window.location.reload();
    } catch (error) { console.error("Force delete failed:", error); alert(t('sync.item.alertForceDeleteFailed')); }
  };

   const handleResyncConfirm = async () => {
    setShowResyncModal(false);
    try {
      await API.del('bridge', '/bridge?resync=true', { body: { sourceCalendarId: item.sourceCalendarId, destCalendarId: item.destCalendarId } });
      window.location.reload();
    } catch (ex) {
      console.error("Resync failed:", ex);
      alert(t('sync.item.alertResyncRateLimit', { date: new Date(item.resynced + 1000 * 60 * 60 * 8).toLocaleString() }));
    }
  };

  const sleep = (time) => new Promise((resolve) => setTimeout(resolve, time));

  const handleRepairConfirm = async () => { // Renamed from bumpSync
      setShowRepairModal(false);
      try {
          setDisableButton(true);
          await API.del('bridge', '/bridge?resync=true&bump=true', { body: { sourceCalendarId: item.sourceCalendarId, destCalendarId: item.destCalendarId } });
          await sleep(1000);
          window.location.reload();
      } catch (ex) {
          console.error("Repair failed:", ex);
          alert(t('sync.item.alertRepairFailed'));
          setDisableButton(false);
      }
  };

  const handleEditConfirm = async () => {
    setShowEditModal(false);
    try {
      await API.del('bridge', '/bridge?edit=true', { body: { sourceCalendarId: item.sourceCalendarId, destCalendarId: item.destCalendarId } });
      window.location.reload();
    } catch (error) { console.error("Edit prep failed:", error); alert(t('sync.item.alertEditPrepFailed')); }
  };
  // --- End Modal Handlers ---

  // Functions to show modals by setting state
  function showDeleteConfirm() { setShowDeleteModal(true); }
  function showForceDeleteConfirm() { setShowForceDeleteModal(true); }
  function showResyncConfirm() { setShowResyncModal(true); }
  function showEditConfirm() { setShowEditModal(true); }
  // Note: bumpSync is now handleRepairConfirm, triggered directly by handleClick

  const handleClick = (e) => {
    console.log("handle click " + e)
    if (e === '0') {
      showForceDeleteConfirm()
    } else if (e === '1') {
      showDeleteConfirm()
    } else if (e === '2') {
      console.log("huh")
      showEditConfirm()
    } else if (e === '3') {
      navigate(
        `/dashboard/syncs/${encodeURIComponent(
          item.id.replace(item.id.replace('#', '___'))
        )}/edit`
      )
    } else if (e === '4') {
      showResyncConfirm()
    } else if (e === '5') {
      setShowRepairModal(true); // Show repair modal instead of calling bumpSync directly
    }
  }

  const menu = (
    <CBMenu onClick={handleClick} style={{ width: 125 }}>
      {/* <Menu.Item key="0">
        <Icon type="stop" />
        Disable
      </Menu.Item> */}

      {item.status == 'delete_error' && (
        <CBMenuItem key="0">
          <div className="flex gap-x-4 items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
              />
            </svg>
            {t('sync.item.menuForceDelete')}
          </div>
        </CBMenuItem>
      )}
      {item.status != 'delete_error' && (
        <CBMenuItem key="1" className="text-red-600" icon={<FontAwesomeIcon icon={faTrashAlt} className="mr-2"/>}>
          {t('common.delete_button')} {/* Reusing common key */}
        </CBMenuItem>
      )}
      {item.status == 'synced_renew' && (
        <CBMenuItem key="3" icon={<FontAwesomeIcon icon={faPencilAlt} className="mr-2"/>}>
          {t('sync.item.menuFinishEdit')}
        </CBMenuItem>
      )}
      {item.status == 'synced' && (
        <CBMenuItem key="2" icon={<FontAwesomeIcon icon={faPencilAlt} className="mr-2"/>}>
          {t('sync.item.menuEdit')}
        </CBMenuItem>
      )}
      {!disableButton &&
        item.lastSyncTime + (5 * 60 * 1000) < new Date().getTime() && // Adjusted time check
        item.status == 'syncing' && (
          <CBMenuItem key="5" icon={<FontAwesomeIcon icon={faWrench} className="mr-2"/>}>
            {t('sync.item.menuRepair')}
          </CBMenuItem>
        )}
      {!item.twoWay &&
        item.status != 'syncing' &&
        item.status != 'deleting' &&
        (item.status == 'synced' || item.status == 'synced_error') && (
          <CBMenuItem key="4" icon={<FontAwesomeIcon icon={faSyncAlt} className="mr-2"/>}>
            {t('sync.item.menuResync')}
          </CBMenuItem>
        )}
    </CBMenu>
  );

  function renderMenuItems() {
    return (
      <div className="flex flex-row gap-2">
        {/* <Menu.Item key="0">
          <Icon type="stop" />
          Disable
        </Menu.Item> */}

        {item.status == 'synced_renew' && (
          <div key="3" onClick={(e) => handleClick('3')}>
            <div className="menu-thing">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
                />
              </svg>
              Finish Edit
            </div>
          </div>
        )}
        {(item.status == 'synced' || item.status == 'synced_error') && (
          <div key="2" onClick={(e) => handleClick('2')}>
            <div className="menu-thing">
              {' '}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
                />
              </svg>
              Edit
            </div>
          </div>
        )}
        {!item.twoWay &&
          item.status != 'syncing' &&
          item.status != 'deleting' &&
          (item.status == 'synced' || item.status == 'synced_error') && (
            <div key="4" onClick={(e) => handleClick('4')}>
              <div className="menu-thing">
                {' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                  />
                </svg>
                Resync
              </div>
            </div>
          )}
        {!disableButton &&
          item.lastSyncTime + 5 * 60 * 1000 < new Date().getTime() &&
          item.status == 'syncing' && (
            <div key="4" onClick={(e) => handleClick('5')}>
              <div className="menu-thing">
                {' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                  />
                </svg>
                Repair
              </div>
            </div>
          )}
        {item.status == 'delete_error' && (
          <div key="0" onClick={(e) => handleClick('0')}>
            <div className="menu-thing">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                />
              </svg>
              Force Delete
            </div>
          </div>
        )}
        {item.status != 'deleting' &&
          item.status != 'syncing' &&
          item.status != 'delete_error' && (
            <div key="1" onClick={(e) => handleClick('1')}>
              <div className="menu-thing">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                  />
                </svg>
                Delete
              </div>
            </div>
          )}
      </div>
    )
  }

  function getTime() {
    if (item.startCutOff == -1) {
      return 'None'
    } else {
      return `${item.startCutOff % 12} ${
        item.startCutOff < 12 ? 'AM' : 'PM'
      } - ${item.endCutOff % 12} ${item.endCutOff < 12 ? 'AM' : 'PM'}`
    }
  }
  function getColor() {
    if (item.filterColor == '11') {
      return (
        <>
          <div
            className="w-4 h-4 rounded-full"
            style={{ background: '#D50000' }}
          />
        </>
      )
    } else if (item.filterColor == '10') {
      return (
        <>
          <div
            className="w-4 h-4 rounded-full"
            style={{ background: '#0B8043' }}
          />
        </>
      )
    } else if (item.filterColor == '3') {
      return (
        <>
          <div
            className="w-4 h-4 rounded-full"
            style={{ background: '#3F51B5' }}
          />
        </>
      )
    } else if (item.filterColor == 'Green category') {
      return (
        <>
          <div
            className="w-4 h-4 rounded-full"
            style={{ background: '#00ff00' }}
          />
        </>
      )
    } else if (item.filterColor == 'Yellow category') {
      return (
        <>
          <div className="w-4 h-4 rounded-full bg-yellow-200" />
          <div>Yellow</div>
        </>
      )
    } else if (item.filterColor == 'Red category') {
      return (
        <>
          <div className="w-4 h-4 rounded-full bg-red-500" />
        </>
      )
    } else if (item.filterColor == 'none') {
      return 'None'
    } else {
      return item.filterColor
    }
  }

  function renderSyncInfo() {
    return (
      <div className="grid lg:grid-cols-3 grid-cols-1 gap-y-2 gap-x-1 items-start flex-wrap ">
        {/* <div className="flex-row flex justify-center gap-2 border pt-2 pb-2">
          <div>Tag:</div>
          <div>
            {item.tag == 'default'
              ? '(copy)'
              : item.tag == ' '
              ? 'No Tag'
              : item.tag}
          </div>
        </div> */}
        <div className="flex-row flex justify-start gap-2 pt-2 pb-2 lg:col-span-2">
          <div className="font-bold">Fields:</div>
          {syncTypeText(
            item.securityPolicy.includes('subject'),
            item.securityPolicy.includes('description'),
            item.securityPolicy.includes('location'),
            item.securityPolicy.includes('reminder'),
            item.securityPolicy.includes('private'),
            item.securityPolicy.includes('meeting'),
            item.securityPolicy.includes('contact'),
            item.securityPolicy.includes('tag')
          )}
        </div>

        <div className="flex-row flex justify-center gap-2 pt-2 pb-2">
          <div className="font-bold">Status:</div>{' '}
          <div>
            {!preview && item.status === 'synced' && 'Active and Up-to-Date'}
            {!preview && item.status === 'syncing' && 'Active and Up-to-Date'}
            {!preview && item.status === 'synced_renew' && (
              <div>Please Complete Edit</div>
            )}
            {!preview && item.status === 'deleting' && <div>Clearing sync</div>}
            {!preview && item.status === 'synced_error' && (
              <div>Sync issue</div>
            )}
            {!preview && item.status === 'sync_conflict' && (
              <div>Sync software conflict</div>
            )}
            {!preview && item.status === 'sync_conflict_onecal' && (
              <div>Sync Disabled</div>
            )}
            {!preview &&
              (item.status === 'synced' || item.status === 'syncing') &&
              (item.sourceCalendarType == 'ics' ||
                item.sourceCalendarType == 'caldav') && (
                <div className="text-xs">
                  ({item.sourceCalendarType == 'caldav' ? 'iCloud' : 'ICS'}{' '}
                  Updates every 5-10 min)
                </div>
              )}
            {item.status !== 'synced' &&
              item.status !== 'synced_renew' &&
              item.status !== 'sync_conflict' &&
              item.status !== 'synced_error' &&
              item.status !== 'deleting' && (
                <div className="flex items-center p-2 flex-grow justify-center">
                     <CBCircularProgress // Use the imported component
                        size={30}
                        strokeWidth={4}
                        percent={Math.round((item.syncProgress / 12) * 100)}
                        status={syncStatusMap[item.status]} // Pass the status prop
                      />
                </div>
              )}
            {syncStatusMap[item.status] == 'exception' && <>{''}</>}
          </div>
        </div>

        {item.hasFilters && (
          <div className="flex-row flex justify-center gap-2 border pt-2 pb-2">
            <div className="font-bold">Filter Status:</div>{' '}
            {syncFilterText(
              item.sourceCalendarType,
              item.syncLevel.includes('free'),
              item.syncLevel.includes('busy'),
              item.syncLevel.includes('tentative'),
              item.syncLevel.includes('oof'),
              item.syncLevel.includes('workingElsewhere')
            )}
          </div>
        )}
        {item.hasFilters && (
          <div className="flex-row flex justify-center gap-2 border pt-2 pb-2 items-center">
            <div className="font-bold">Filter Color:</div> {getColor()}
          </div>
        )}
        {item.hasFilters && item.sourceCalendarType == 'google' ? (
          <div className="flex-row flex justify-center gap-2 border pt-2 pb-2">
            <div className="font-bold">Exclude unconfirmed:</div>{' '}
            {item.excludeInvites ? 'Yes' : 'No'}
          </div>
        ) : (
          <div></div>
        )}
      </div>
    )
  }

// Removed the original, redundant return statement block (lines 803-1063)


  return (<><div className="rounded-sm border border-neutral_1 mb-10 flex flex-col shadow-md">
        {/* ... existing component structure ... */}
        <div className="flex flex-col pl-4 pr-4">
          {/* ... */}
          {renderSyncLeg(
            getTypeIcon,
            item,
            sourceAccount,
            preview,
            destAccount,
            'source'
          )}
          {/* ... */}
        </div>
        
        <div className=" p-2 flex flex-col justify-center">
          {!preview ? (
            <>
              <div>{renderSyncInfo()}</div>
              {/* ... existing list items removed for brevity ... */}
            </>
          ) : (
             <CBList>
              {/* ... preview list items ... */}
              <CBListItem
                border={false}
                icon={
                  <div className={'rounded-full p-2 bg-white text-sm'}>
                    {item.tag == 'default'
                      ? '(copy)'
                      : item.tag == ' '
                      ? 'No Tag'
                      : item.tag}
                  </div>
                }
              >
                Tag
              </CBListItem>
              <CBListItem
                border={false}
                icon={
                  <div className={'rounded-full p-2 bg-white text-sm'}>
                    {syncTypeText(
                      item.securityPolicy.includes('subject'),
                      item.securityPolicy.includes('description'),
                      item.securityPolicy.includes('location'),
                      item.securityPolicy.includes('reminder'),
                      item.securityPolicy.includes('private'),
                      item.securityPolicy.includes('meeting'),
                      item.securityPolicy.includes('contact')
                    )}
                  </div>
                }
              >
                Fields
              </CBListItem>
                
              <CBListItem
                border={false}
                icon={
                  <div className={'rounded-full p-2 bg-white text-sm'}>
                    {item.destinationColor != 'default' ? (
                      <ColorPicker type={item.destCalendarType} color={item.destinationColor} preview={true} />
                    ) : (
                      <div>{t('sync.item.timeNone')}</div> 
                    )}
                    {item.matchColors && (
                      <div className="mt-2">Match Source Colors</div>
                    )}
                  </div>
                }
              >
                Color
              </CBListItem>
            </CBList>
          )}
          {preview && item.hasFilters && (
            <CBList>
              <CBListItem border={false} icon={<div className={''}></div>}>
                Event Filtering
              </CBListItem>

              <CBListItem
                border={false}
                icon={
                  <div className={'rounded-full p-2 lg:bg-white text-sm'}>
                    {syncFilterText(
                      item.sourceCalendarType,
                      item.syncLevel.includes('free'),
                      item.syncLevel.includes('busy'),
                      item.syncLevel.includes('tentative'),
                      item.syncLevel.includes('oof'),
                      item.syncLevel.includes('workingElsewhere')
                    )}
                  </div>
                }
              >
                Filter Status
              </CBListItem>

              <CBListItem
                border={false}
                icon={
                  <div className={'rounded-full p-2 lg:bg-white text-sm'}>
                    {getColor()}
                  </div>
                }
              >
                Filter Color
              </CBListItem>
              {item.sourceCalendarType == 'google' ? (
                <CBListItem
                  border={false}
                  icon={
                    <div className={'rounded-full p-2 lg:bg-white text-sm'}>
                      {item.excludeInvites ? 'Yes' : 'No'}
                    </div>
                  }
                >
                  Exclude unconfirmed invites
                </CBListItem>
              ) : (
                <CBListItem
                  border={false}
                  icon={<div className={''}></div>}
                ></CBListItem>
              )}
            </CBList>
          )}
          {syncStatusMap[item.status] == 'exception' && (
            <div className="mt-2">{resolveError()}</div>
          )}
          {!preview && (
            <div className="relative">
              <div className="absolute lg:-right-0 -right-0 -top-1">
                {renderMenuItems()}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* --- Modals --- */}
      <CBModal
        
        visible={showDeleteModal}
        onPositiveClick={handleDeleteConfirm}
        onCancelClick={() => setShowDeleteModal(false)}
        positiveLabel={t('common.delete_button')} // Assuming localization key exists
        negativeLabel={t('common.cancel_button')} // Assuming localization key exists
        positiveButtonProps={{ className: 'bg-red-600 hover:bg-red-700' }}
        title={
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faTrashAlt} className="text-red-600" />
            {t('sync.delete_confirm_title')}
          </div>
        }
      >
        <p>{t('sync.delete_confirm_message')}</p>
      </CBModal>

      <CBModal
        visible={showForceDeleteModal}
        onPositiveClick={handleForceDeleteConfirm}
        onCancelClick={() => setShowForceDeleteModal(false)}
        positiveLabel={t('sync.force_delete_button')}
        negativeLabel={t('common.cancel_button')}
        positiveButtonProps={{ className: 'bg-red-600 hover:bg-red-700' }}
        title={
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faTrashAlt} className="text-red-600" />
            {t('sync.force_delete_confirm_title')}
          </div>
        }
      >
        <p>{t('sync.force_delete_confirm_message')}</p>
      </CBModal>

      <CBModal
        visible={showResyncModal}
        onPositiveClick={handleResyncConfirm}
        onCancelClick={() => setShowResyncModal(false)}
        positiveLabel={t('sync.resync_button')}
        negativeLabel={t('common.cancel_button')}
        positiveButtonProps={{ className: 'bg-orange-600 hover:bg-orange-700' }} // Example color
        title={
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faSyncAlt} className="text-orange-600" />
            {t('sync.resync_confirm_title')}
          </div>
        }
      >
        <p>{t('sync.resync_confirm_message')}</p>
      </CBModal>

      <CBModal
        visible={showEditModal}
        onPositiveClick={handleEditConfirm}
        onCancelClick={() => setShowEditModal(false)}
        positiveLabel={t('sync.edit_button')}
        negativeLabel={t('common.cancel_button')}
        positiveButtonProps={{ className: 'bg-blue-600 hover:bg-blue-700' }} // Example color
        title={
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faPencilAlt} className="text-blue-600" />
            {t('sync.edit_confirm_title')}
          </div>
        }
      >
        <p>{t('sync.edit_confirm_message')}</p>
      </CBModal>

       <CBModal
        visible={showRepairModal}
        onPositiveClick={handleRepairConfirm}
        onCancelClick={() => { setShowRepairModal(false); setDisableButton(false); }} // Also reset disableButton on cancel
        positiveLabel={t('sync.repair_button')}
        negativeLabel={t('common.cancel_button')}
        positiveButtonProps={{ className: 'bg-green-600 hover:bg-green-700' }} // Example color
        title={
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faWrench} className="text-green-600" />
            {t('sync.repair_confirm_title')}
          </div>
        }
        disabled={disableButton} // Disable buttons while repairing
      >
        <p>{t('sync.repair_confirm_message')}</p>
      </CBModal>
      {/* --- End Modals --- */}
    </>
  )
}

export default SyncItem
function renderSyncLeg(
  getTypeIcon,
  item,
  sourceAccount,
  preview,
  destAccount,
  leg = 'source'
) {
  const sourceAccountType = leg === 'source' ? item.sourceCalendarType : item.destCalendarType;
  const sourceCalendarName = leg === 'source' ? item.sourceCalendarName : item.destCalendarName;
  const sourceCalendarEmail = leg === 'source' ? sourceAccount.email : destAccount.email;
  const destAccountType = leg === 'source' ? item.destCalendarType : item.sourceCalendarType;
  const destCalendarName = leg === 'source' ? item.destCalendarName : item.sourceCalendarName;
  const destCalendarEmail = leg === 'source' ? destAccount.email : sourceAccount.email;
  // Use item.destinationColor consistently
  const destinationColor = leg === 'source' ? item.destinationColor : item.sourceColor;

  return (
    // Replaced Row/Col with Grid
    <div className="grid grid-cols-1 lg:grid-cols-3 items-center justify-center justify-items-center p-2">
      {/* Source Column */}
      <div className="flex flex-col text-center justify-items-center pl-2 mb-2 lg:mb-0  lg:ml-8">
        <div className="text-lg gap-2 flex flex-row items-center justify-center lg:justify-start">
          <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">{getTypeIcon(sourceAccountType)}</div> {/* Ensure icon size */}
          <div className="w-64 truncate text-left font-semibold">{sourceCalendarName}</div>
        </div>
        <div className="p-1 text-sm text-gray-600">
          {item.sourceCalendarType !== 'ics' && (
            <div className="w-64 truncate mx-auto lg:mx-0">{sourceCalendarEmail}</div>
          )}
          {item.sourceCalendarType === 'ics' && (
            <div className="w-64 truncate mx-auto lg:mx-0">...{item.sourceCalendarId.slice(-30)}</div>
          )}
        </div>
      </div>

      {/* Arrow Column */}
      <div className="flex flex-col justify-center font-manrope text-2xl text-center mx-4">
        <div>{item.twoWay ? '<-->' : '->'}</div>
        {/* Tag and Color Preview (Optional) */}
        <div className="text-xs flex flex-col items-center mt-1">
            {/* {item.tag !== 'default' && item.tag !== ' ' && <span className=" px-1 rounded">{item.tag}</span>}
            {destinationColor && destinationColor !== 'default' && destinationColor !== 'same' && (
                 <ColorPicker type={destAccountType} color={destinationColor} preview={true} />
            )} */}
        </div>
      </div>

      {/* Destination Column */}
      <div className="flex flex-col text-center justify-items-center mt-2 lg:mt-0">
        <div className="text-lg gap-2 flex flex-row items-center justify-center lg:justify-start">
          <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">{getTypeIcon(destAccountType)}</div> {/* Ensure icon size */}
          <div className="w-64 truncate text-left font-semibold">{destCalendarName}</div>
        </div>
        <div className="p-1 text-sm text-gray-600">
          <div className="w-64 truncate mx-auto lg:mx-0">{destCalendarEmail}</div>
        </div>
      </div>
    </div>
  )
}
